(ns app.front.view.application-wizard.renewal-overview
  (:require [app.front.view.application-wizard.summary :as summary]
            [clojure.string :as str]))

(defn description [tr]
  (tr [:application-wizard/renewal-overview-description]
      [(str/lower-case (tr [:application-wizard/renewal-item]))]))

(defn view [tr]
  [summary/overview-view tr {:renewal-overview? true}])
